// Centralized version management for XCOIN Dashboard
// This file is AUTO-GENERATED during build process
// DO NOT hardcode versions anywhere else in the codebase

// Version is injected from package.json during build
// process.env is used as fallback for tests, __APP_VERSION__ is injected by Vite
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

// Build timestamp for debugging
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || 'unknown';

// Build hash for cache busting
export const BUILD_HASH = import.meta.env.VITE_BUILD_HASH || 'dev';

// Full version string for display
export const VERSION_STRING = APP_VERSION;

// Detailed build info for debugging
export const BUILD_INFO = {
    version: APP_VERSION,
    buildDate: BUILD_DATE,
    buildHash: BUILD_HASH,
    environment: import.meta.env.MODE || 'development'
};

// Helper to log version info (useful for debugging)
export const logVersionInfo = () => {
    console.log('='.repeat(50));
    console.log('XCOIN Dashboard - Build Information');
    console.log('='.repeat(50));
    console.log(`Version: ${APP_VERSION}`);
    console.log(`Build Date: ${BUILD_DATE}`);
    console.log(`Build Hash: ${BUILD_HASH}`);
    console.log(`Environment: ${BUILD_INFO.environment}`);
    console.log('='.repeat(50));
};

export default {
    APP_VERSION,
    BUILD_DATE,
    BUILD_HASH,
    VERSION_STRING,
    BUILD_INFO,
    logVersionInfo
};
